import React, { useState } from "react";
import { FiCheck, FiGlobe, FiInfo } from "react-icons/fi";

export default function LanguageView() {
  const [selectedLanguage, setSelectedLanguage] = useState("es");
  const [savedLanguage, setSavedLanguage] = useState("es");

  const languages = [
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "pt", name: "Português", flag: "🇵🇹" },
    { code: "it", name: "Italiano", flag: "🇮🇹" }
  ];

  const handleLanguageChange = (languageCode) => {
    setSelectedLanguage(languageCode);
  };

  const handleSaveChanges = () => {
    setSavedLanguage(selectedLanguage);
    console.log("Language saved:", selectedLanguage);
    // Here you would typically make an API call to save the language preference
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="p-6 border-b">
        <h1 className="text-2xl font-bold text-navy-900 flex items-center">
          <FiGlobe className="mr-2" /> Configuración de Idioma
        </h1>
        <p className="text-gray-600 mt-2">
          Selecciona el idioma preferido para Lawfeed.
        </p>
      </div>

      <div className="p-6">
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Idioma de la Interfaz</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {languages.map((language) => (
              <div 
                key={language.code}
                className={`p-4 rounded-lg border cursor-pointer flex items-center justify-between ${
                  selectedLanguage === language.code
                    ? "border-navy-600 bg-navy-50"
                    : "border-gray-200 hover:border-navy-300"
                }`}
                onClick={() => handleLanguageChange(language.code)}
              >
                <div className="flex items-center">
                  <span className="text-2xl mr-3">{language.flag}</span>
                  <span className="font-medium">{language.name}</span>
                </div>
                {selectedLanguage === language.code && (
                  <FiCheck className="h-5 w-5 text-navy-600" />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <div className="flex items-start p-4 bg-blue-50 rounded-lg">
            <FiInfo className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h3 className="font-medium text-blue-800">Información sobre idiomas</h3>
              <p className="text-sm text-blue-700 mt-1">
                El cambio de idioma afectará a toda la interfaz de usuario de Lawfeed. 
                Los documentos y contenido generado previamente mantendrán su idioma original.
                Algunos términos legales específicos pueden mantenerse en su idioma original por precisión.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Formato de Fecha y Hora</h2>
          <div className="space-y-4">
            <div className="flex flex-col space-y-2">
              <label className="text-sm font-medium text-gray-700">Formato de fecha</label>
              <select
                className="border border-gray-300 rounded-md p-2"
                defaultValue="dd/mm/yyyy"
              >
                <option value="dd/mm/yyyy">DD/MM/YYYY</option>
                <option value="mm/dd/yyyy">MM/DD/YYYY</option>
                <option value="yyyy-mm-dd">YYYY-MM-DD</option>
              </select>
            </div>
            <div className="flex flex-col space-y-2">
              <label className="text-sm font-medium text-gray-700">Formato de hora</label>
              <select
                className="border border-gray-300 rounded-md p-2"
                defaultValue="24h"
              >
                <option value="24h">24 horas (14:30)</option>
                <option value="12h">12 horas (2:30 PM)</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Zona Horaria</h2>
          <div className="flex flex-col space-y-2">
            <label className="text-sm font-medium text-gray-700">Selecciona tu zona horaria</label>
            <select
              className="border border-gray-300 rounded-md p-2"
              defaultValue="Europe/Madrid"
            >
              <option value="Europe/Madrid">Madrid (UTC+1)</option>
              <option value="America/Mexico_City">Ciudad de México (UTC-6)</option>
              <option value="America/Bogota">Bogotá (UTC-5)</option>
              <option value="America/Santiago">Santiago (UTC-4)</option>
              <option value="America/Buenos_Aires">Buenos Aires (UTC-3)</option>
              <option value="America/Lima">Lima (UTC-5)</option>
            </select>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-between">
            <button
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              onClick={() => setSelectedLanguage("es")}
            >
              Restablecer Valores Predeterminados
            </button>
            <button
              className="px-4 py-2 bg-navy-600 text-white hover:bg-navy-700 rounded"
              onClick={handleSaveChanges}
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}